import { NoteRegularV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import { noNamer } from "../../../../Contacts/ModalViews/helpers";
import DataField from "./DataField";

const LoanNotesUpdatedActivity = ({ activity, onReadChange }) => {
  return (
    <ActivityContainer activity={activity} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName="tw-bg-[#FAF1E6] tw-text-[#AD6714]" Icon={NoteRegularV6}>
            Loan Notes Updated
          </CategoryContainer>
        }
        personName={noNamer(activity.data?.subjectFirstName, activity.data?.subjectLastName)}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        {activity.data?.notes && <DataField label="Notes" data={activity.data?.notes} />}
        {activity.data?.transactionName && (
          <DataField label="Transaction" data={activity.data?.transactionName} />
        )}
      </div>
    </ActivityContainer>
  );
};

export default LoanNotesUpdatedActivity;

LoanNotesUpdatedActivity.propTypes = {
  ...activityCommonPropTypes,
};

LoanNotesUpdatedActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
